import { useTranslation } from "react-i18next";
import { FilterSummary } from "./FiltersSummary";
import { DateFormats } from "../../types/DateFormats";
import moment from "moment";

export const UpdateSummary = ({ tasks, filters, updates }) => {
  const { t } = useTranslation(["BulkUpdateTasksModal", "Shared"]);

  const getValue = (update) => {
    const sttgs = update?.settings;
    if (update.displayValue) {
      return Array.isArray(update.displayValue)
        ? update.displayValue.join?.(", ")
        : update.displayValue;
    } else if (Array.isArray(update?.value)) {
      update.value.map((x) => getValue({ ...update, value: x })).join(",");
    } else if (sttgs?.type === "date")
      return getDateFilterDisplayValue(update.value);
    else if (sttgs.type === "boolean")
      return getBooleanDisplayValue(update.value, sttgs);
    else return `${update.value}`;
  };

  const getBooleanDisplayValue = (value, fieldSettings) => {
    return fieldSettings.noTranslations
      ? value
        ? t("Shared:Yes")
        : t("Shared:No")
      : t(`BooleanLabels.${fieldSettings.headerText}.${value}`);
  };

  const getDateFilterDisplayValue = (value) =>
    moment(value).format(DateFormats.ShortDateFormat.momentJsFormat);

  const getComponent = (update) => {
    switch (update.field) {
      case "Tags":
        return tagTemplate(update);
      case "TaskTaxReturnInfo.TaxDeadline":
        return taxDeadlineTemplate(update);
      default:
        return defaultTemplate(update);
    }
  };

  const getHeaderText = (update) => {
    const label = update.settings.noTranslations
      ? update.settings.headerText
      : t("Columns." + update.settings.headerText);

    switch (update.field) {
      case "TaskTaxReturnInfo.TaxDeadline":
        return label;
      default:
        return (
          label + (update?.action ? ` (${t(`Review.${update.action}`)})` : "")
        );
    }
  };

  const tagTemplate = (update) => {
    return (
      <div className="d-inline-flex flex-wrap gap-1">
        {update.displayValue.map((x, i) => (
          <span
            key={x ?? i}
            className="rounded-pill bg-et-light-blue px-2 py-1 bg-et-blue-light-1"
          >
            {x}
          </span>
        ))}
      </div>
    );
  };

  const taxDeadlineTemplate = (update) => {
    let cont = "";
    if (
      update.action === "SpecificDate" ||
      update.action === "ApplySpecificExtension"
    ) {
      cont = getDateFilterDisplayValue(update.value.dateValue);
    } else if (update.action === "RemoveExtension") {
      cont = (
        <div className="bg-et-lightest-gray p-3 rounded mb-2">
          {t("TaxDeadline.RemoveExtensionDescription")}
        </div>
      );
    } else if (update.action === "ApplyExtension") {
      cont = (
        <div className="bg-et-lightest-gray p-3 rounded mb-2">
          {t("TaxDeadline.ApplyExtensionDescription")}
        </div>
      );
    }

    return (
      <>
        <div className="fw-600 mb-1">{t("TaxDeadline." + update.action)}</div>
        <div>{cont}</div>
        {update?.value?.updateDueDate && (
          <span>{t("TaxDeadline.UpdateDueDate")}</span>
        )}
      </>
    );
  };

  const defaultTemplate = (update) => (
    <span className="update-summary-value fw-600">{getValue(update)}</span>
  );

  const Row = ({ content: update }) => {
    return (
      <>
        <div className="update-summary-row">
          <span>{getHeaderText(update)}</span>
          <div>{getComponent(update)}</div>
        </div>
        <div className="border-bottom border-et-light-gray divider" />
      </>
    );
  };

  return (
    <div className="et-update-summary border border-et-light-gray rounded">
      <FilterSummary
        filters={filters?.filter((item) => item.value?.length !== 0)}
        tasks={tasks}
        isUpdateSummary
      />

      <div className="updates-container d-flex flex-column gap-2 p-3 rounded border border-et-blue overflow-auto">
        <div className="fw-600 py-2">{t("Review.UpdatesHeader")}</div>
        {Object.values(updates)
          ?.filter((update) => update.hasValue ?? !!update?.value)
          .map((update) => (
            <Row key={update.field} content={update} />
          ))}
      </div>
    </div>
  );
};
